import Page from 'src/components/Page';
import TabsPageLayout from 'src/components/TabsPageLayout';
import { pagesText } from 'src/constants/pagesText';
import { CUSTOMER_QUERY_KEY, ENVIRONMENT_NAME_QUERY_KEY } from 'src/constants/query';
import { PORTAL_ROUTE } from 'src/constants/routes';
import useQueryData from 'src/queries/useQueryData';
import { companyNameSelector } from 'src/selectors/customer';
import { DEPLOYMENT_RINGS_ROUTE, ENVIRONMENT_TABS } from './constants';
import { useCanViewDeploymentRings } from 'src/utils/featureFlags';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { useQuery } from 'react-query';
import EnvironmentGuard from 'src/components/EnvironmentGuard';
import ApplicationsService from 'src/services/applications.service';

const Environment = () => {
  const companyName = useQueryData(CUSTOMER_QUERY_KEY, companyNameSelector);
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const canViewDeploymentRings = useCanViewDeploymentRings();
  const tabs = ENVIRONMENT_TABS.filter(
    tab => canViewDeploymentRings || tab.value !== DEPLOYMENT_RINGS_ROUTE,
  );

  const { data: environment } = useQuery(
    [ENVIRONMENT_NAME_QUERY_KEY, customerEnvId],
    () => ApplicationsService.getEnvironment(customerEnvId),
    { enabled: !!customerEnvId, refetchOnWindowFocus: false },
  );

  return (
    <Page
      title={pagesText.environment.title}
      breadcrumbs={[
        { label: companyName, route: `${PORTAL_ROUTE}/apps` },
        { label: environment?.name || 'Environment' },
      ]}>
      <EnvironmentGuard>
        <TabsPageLayout
          tabs={tabs}
          wrapperProps={{
            sx: {
              maxWidth: '100%',
            },
          }}
        />
      </EnvironmentGuard>
    </Page>
  );
};

export default Environment;
